import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ff305a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Baixa de Contas a Receber", -1))
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1))
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1))
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-8",
  style: {"padding-top":"4px"}
}
const _hoisted_14 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir Baixa", -1))
const _hoisted_16 = { class: "ss-tela-conteudo" }
const _hoisted_17 = { class: "ss-card ss-card-space" }
const _hoisted_18 = { class: "ant-row ss-ocultar-mobile" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA")
], -1))
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-2 ss-alinhar-titulo-valores" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"25px"} }, "Juros")
], -1))
const _hoisted_28 = { class: "ant-col ant-col-xs-20 ant-col-xl-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "O valor do Juros será calculado utilizando o percentual definido no cadastro de cada cliente, caso não houver será utilizado o percentual abaixo.", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"25px"} }, "Multa", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "ant-col ant-col-xs-20 ant-col-xl-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "O valor da Multa será calculada utilizando o percentual definido no cadastro de cada cliente, caso não houver será utilizado o percentual abaixo.", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"25px"} }, "Desconto", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "ant-col ant-col-xs-20 ant-col-xl-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "O valor do Desconto será calculado utilizando o percentual definido no cadastro de cada cliente, caso não houver será utilizado o percentual abaixo.", -1))
const _hoisted_38 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-3"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selecione os títulos que deseja baixar", -1))
const _hoisted_40 = {
  class: "ant-row",
  style: {"margin-bottom":"15px"}
}
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_42 = { class: "ant-input-wrapper ant-input-group ss-alinhar-texto-esquerda" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "NÚMERO TÍTULO:", -1))
const _hoisted_44 = ["title"]
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Atraso:", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Título:", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Juros/Multa:", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Acréscimo:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Desconto:", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Total:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-bottom":"10px"}
}, null, -1))
const _hoisted_60 = {
  class: "ant-row",
  style: {"padding-left":"5px","padding-bottom":"5px"}
}
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_63 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_64 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_65 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Acréscimos ou Descontos adicionais", -1))
const _hoisted_69 = { class: "ant-row" }
const _hoisted_70 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_71 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_72 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_73 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_74 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, null, -1))
const _hoisted_76 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-alinhar-centro" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Utilizar créditos", -1))
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Criar novos Títulos/Renegociar", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Recebimento normal", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Prévia da Baixa", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-titulo-lancamentos-baixa" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Baseado nas informações fornecidas serão criadas as seguintes Movimentações de Contas:")
], -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = { key: 3 }
const _hoisted_87 = { key: 4 }
const _hoisted_88 = { key: 5 }
const _hoisted_89 = { key: 6 }
const _hoisted_90 = {
  key: 7,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Identificador:", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descrição:", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Influência Saldo:", -1))
const _hoisted_98 = { class: "ant-row" }
const _hoisted_99 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-3"
}
const _hoisted_100 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_101 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_102 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_103 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_104 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_105 = { class: "ss-alinhar-texto-esquerda" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_selecionar_titulo_financeiro_por_numero = _resolveComponent("selecionar-titulo-financeiro-por-numero")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_selecionar_tipo_valor_financeiro = _resolveComponent("selecionar-tipo-valor-financeiro")!
  const _component_baixa_titulos_utilizacao_credito = _resolveComponent("baixa-titulos-utilizacao-credito")!
  const _component_baixa_titulos_lancamento_carteira = _resolveComponent("baixa-titulos-lancamento-carteira")!
  const _component_baixa_titulos_lancamento = _resolveComponent("baixa-titulos-lancamento")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_baixa_titulos_lancamento_creditos = _resolveComponent("baixa-titulos-lancamento-creditos")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_buscar_titulos_modal = _resolveComponent("buscar-titulos-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.baixaTitulosBase.identificadorRecurso, [_ctx.baixaTitulosBase.empresaSelecionada]))
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "bottom"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_9
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.baixaTitulosBase.identificadorRecurso, [_ctx.baixaTitulosBase.empresaSelecionada])))
                          }, [
                            _createElementVNode("i", _hoisted_10, [
                              _createVNode(_component_icone, { nome: "estrela" })
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        placement: "bottom"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.baixaTitulosBase.identificadorRecurso, [_ctx.baixaTitulosBase.empresaSelecionada])))
                          }, [
                            _createElementVNode("i", _hoisted_12, [
                              _createVNode(_component_icone, { nome: "favorito" })
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-block",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmacaoLimparTela()))
                }, " Cancelar "),
                (_ctx.verificarConclusaoBaixa())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela ant-btn-block",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmacaoBaixa()))
                    }, [
                      _createVNode(_component_icone, { nome: "correto" }),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_select, {
                        class: "ss-tamanho-completo",
                        value: _ctx.baixaTitulosBase.empresaSelecionada,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.baixaTitulosBase.empresaSelecionada) = $event)),
                        options: _ctx.telaBase.empresasDisponiveis,
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas
                      }, null, 8, ["value", "options", "onChange"])
                    ])
                  ]),
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.baixaTitulosBase.carregandoParametros
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, { label: "Data da Baixa" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.baixaTitulosBase.dataBaixa,
                                "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.baixaTitulosBase.dataBaixa) = $event)),
                                horaMinuto: true,
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verificacaoAlteracaoData()))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria - Juros/Multa",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.baixaTitulosBase.categoriaPadraoJurosMulta,
                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.baixaTitulosBase.categoriaPadraoJurosMulta) = $event)),
                                empresas: [_ctx.baixaTitulosBase.empresaSelecionada]
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria - Desconto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.baixaTitulosBase.categoriaPadraoDesconto,
                                "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.baixaTitulosBase.categoriaPadraoDesconto) = $event)),
                                empresas: [_ctx.baixaTitulosBase.empresaSelecionada]
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Apresentar títulos calculando")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_a_form_item, { label: "Atraso em dias" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio_group, {
                                value: _ctx.baixaTitulosBase.diasUteis,
                                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.baixaTitulosBase.diasUteis) = $event)),
                                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.verificacaoCalculo())),
                                "button-style": "solid"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_button, { value: false }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("CORRRIDOS")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_radio_button, { value: true }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("ÚTEIS")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                title: _withCtx(() => [
                                  _hoisted_29
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.baixaTitulosBase.percentualJurosCliente,
                                    "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.baixaTitulosBase.percentualJurosCliente) = $event)),
                                    disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.verificacaoCalculo()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Juros Cliente")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.baixaTitulosBase.percentualJuros,
                                "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.baixaTitulosBase.percentualJuros) = $event)),
                                disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.verificacaoCalculo()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.baixaTitulosBase.calcularValoresTitulos?'ant-col ant-col-xs-4 ant-col-xl-2 ss-alinhar-titulo-valores':'ant-col ant-col-xs-4 ant-col-xl-2 ss-alinhar-titulo-valores')
                        }, _hoisted_31, 2),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                title: _withCtx(() => [
                                  _hoisted_33
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.baixaTitulosBase.percentualMultaCliente,
                                    "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.baixaTitulosBase.percentualMultaCliente) = $event)),
                                    disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.verificacaoCalculo()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Multa Cliente")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.baixaTitulosBase.percentualMulta,
                                "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.baixaTitulosBase.percentualMulta) = $event)),
                                disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.verificacaoCalculo()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.baixaTitulosBase.calcularValoresTitulos?'ant-col ant-col-xs-4 ant-col-xl-2 ss-alinhar-titulo-valores':'ant-col ant-col-xs-4 ant-col-xl-2 ss-alinhar-titulo-valores')
                        }, _hoisted_35, 2),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                title: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.baixaTitulosBase.percentualDescontoCliente,
                                    "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.baixaTitulosBase.percentualDescontoCliente) = $event)),
                                    disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.verificacaoCalculo()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Desconto Cliente")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.baixaTitulosBase.percentualDesconto,
                                "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.baixaTitulosBase.percentualDesconto) = $event)),
                                disabled: !_ctx.baixaTitulosBase.alteracaoPercentuais,
                                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.verificacaoCalculo()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.baixaTitulosBase.calcularValoresTitulos)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createVNode(_component_a_form_item, {
                                label: " ",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    class: "ant-btn ant-btn-primary",
                                    style: {"width":"100%"},
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.calcularValores(true)))
                                  }, "Calcular")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_collapse, {
              activeKey: _ctx.baixaTitulosBase.passoAtivo,
              "onUpdate:activeKey": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.baixaTitulosBase.passoAtivo) = $event)),
              accordion: "",
              onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.verificarPassos()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  collapsible: _ctx.baixaTitulosBase.carregandoParametros?'disabled':''
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("1º Passo")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_39
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _hoisted_43,
                          _createVNode(_component_selecionar_titulo_financeiro_por_numero, {
                            empresas: [_ctx.baixaTitulosBase.empresaSelecionada],
                            tipoTitulo: _ctx.ETipoTituloFinanceiro.Receber,
                            dispararEventoSelecionarTitulo: true,
                            apenasTitulosPendentes: true,
                            codigoSelecionado: _ctx.baixaTitulosBase.codigoTituloPesquisa,
                            "onUpdate:codigoSelecionado": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.baixaTitulosBase.codigoTituloPesquisa) = $event)),
                            placeholder: 'Digite o número do título que deseja adicionar',
                            onTitulosSelecionados: _cache[25] || (_cache[25] = ($event: any) => (_ctx.popularTitulosBaixa($event)))
                          }, null, 8, ["empresas", "tipoTitulo", "codigoSelecionado"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "TÍTULOS ADICIONADOS NA BAIXA"
                    }, {
                      AcoesExtra: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "ss-fonte-negrito ss-card-botao-acao-extra",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.buscarTitulos()))
                        }, "BUSCAR TÍTULOS")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.baixaTitulosBase.titulosBaixa,
                          rowKey: "codigoTituloFinanceiro",
                          pagination: false,
                          loading: _ctx.telaBase.carregando,
                          scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150), y: 500 },
                          "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record, text, index }) => [
                            (column.key === 'TipoDocumentoFinanceiro')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  title: record.descricaoTipoDocumentoFinanceiro
                                }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_44))
                              : (column.key === 'ValorJurosMulta')
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 1,
                                    dataAttributeColuna: column.key,
                                    valor: record.valorJurosMulta,
                                    "onUpdate:valor": ($event: any) => ((record.valorJurosMulta) = $event),
                                    onValorDigitado: ($event: any) => (_ctx.valorJurosMultaDigitado(index)),
                                    classCss: "ss-campo-numero-table ss-baixa-contas-receber-titulos-adicionados",
                                    onKeydown: [
                                      _cache[27] || (_cache[27] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[29] || (_cache[29] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["left"])),
                                      _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent"]), ["right"])),
                                      _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                                      _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                                    ]
                                  }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "onValorDigitado", "onKeydown"]))
                                : (column.key === 'ValorAcrescimo')
                                  ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                      key: 2,
                                      dataAttributeColuna: column.key,
                                      valor: record.valorAcrescimo,
                                      "onUpdate:valor": ($event: any) => ((record.valorAcrescimo) = $event),
                                      onValorDigitado: ($event: any) => (_ctx.valorAcrescimoDigitado(index)),
                                      classCss: "ss-campo-numero-table ss-baixa-contas-receber-titulos-adicionados",
                                      onKeydown: [
                                        _cache[31] || (_cache[31] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                        _cache[32] || (_cache[32] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                        _cache[33] || (_cache[33] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["left"])),
                                        _cache[34] || (_cache[34] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent"]), ["right"])),
                                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                                      ]
                                    }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "onValorDigitado", "onKeydown"]))
                                  : (column.key === 'ValorDesconto')
                                    ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                        key: 3,
                                        dataAttributeColuna: column.key,
                                        valor: record.valorDesconto,
                                        "onUpdate:valor": ($event: any) => ((record.valorDesconto) = $event),
                                        onValorDigitado: ($event: any) => (_ctx.valorDescontoDigitado(index)),
                                        classCss: "ss-campo-numero-table ss-baixa-contas-receber-titulos-adicionados",
                                        onKeydown: [
                                          _cache[35] || (_cache[35] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                          _cache[36] || (_cache[36] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                          _cache[37] || (_cache[37] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["left"])),
                                          _cache[38] || (_cache[38] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent"]), ["right"])),
                                          _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                                          _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                                        ]
                                      }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "onValorDigitado", "onKeydown"]))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                                        : (column.key === 'TituloFinanceiro')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                              _createElementVNode("span", null, [
                                                _hoisted_48,
                                                _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_49,
                                                _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_50,
                                                _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_51,
                                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_52,
                                                _createTextVNode(" " + _toDisplayString(record.diasAtraso), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_53,
                                                _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2)), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_54,
                                                _createTextVNode(),
                                                _createVNode(_component_campo_numerico, {
                                                  monetario: true,
                                                  valor: record.valorJurosMulta,
                                                  "onUpdate:valor": ($event: any) => ((record.valorJurosMulta) = $event),
                                                  onValorDigitado: ($event: any) => (_ctx.valorJurosMultaDigitado(index)),
                                                  classCss: "ss-campo-numero-table"
                                                }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_55,
                                                _createTextVNode(),
                                                _createVNode(_component_campo_numerico, {
                                                  monetario: true,
                                                  valor: record.valorAcrescimo,
                                                  "onUpdate:valor": ($event: any) => ((record.valorAcrescimo) = $event),
                                                  onValorDigitado: ($event: any) => (_ctx.valorAcrescimoDigitado(index)),
                                                  classCss: "ss-campo-numero-table"
                                                }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_56,
                                                _createTextVNode(),
                                                _createVNode(_component_campo_numerico, {
                                                  monetario: true,
                                                  valor: record.valorDesconto,
                                                  "onUpdate:valor": ($event: any) => ((record.valorDesconto) = $event),
                                                  onValorDigitado: ($event: any) => (_ctx.valorDescontoDigitado(index)),
                                                  classCss: "ss-campo-numero-table"
                                                }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_57,
                                                _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2)), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _hoisted_58,
                                                _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            (_ctx.baixaTitulosBase.titulosBaixa.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Nenhum título adicionado ainda"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, [
                          ((_ctx.gradeBase.codigosSelecionados.length > 0))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "ant-btn ant-btn-secondary",
                                style: {"margin-right":"5px"},
                                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.removerTitulosMarcados()))
                              }, "Remover Selecionados"))
                            : _createCommentVNode("", true),
                          ((_ctx.baixaTitulosBase.titulosBaixa.length > 0))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "ant-btn ant-btn-secondary",
                                style: {"margin-left":"5px"},
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.removerTodosTitulos()))
                              }, "Remover Todos"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "TOTALIZADORES"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_totalizador, {
                              titulo: "QTDE TÍTULOS",
                              monetario: false,
                              valor: _ctx.baixaTitulosBase.titulosBaixa.length,
                              casasDecimais: 0
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL TÍTULOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalTitulos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL JUROS/MULTA",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalJurosMulta
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL ACRÉSCIMOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalAcrescimos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL DESCONTO",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalDesconto
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Total dos Títulos + Juros/Multas + Acréscimos - Descontos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_totalizador, {
                                  titulo: "TOTAL TÍTULOS (J + M + A - D)",
                                  monetario: true,
                                  valor: _ctx.baixaTitulosBase.totalFinal
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "2",
                  collapsible: _ctx.baixaTitulosBase.titulosBaixa.length > 0?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("2º Passo")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_68
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_card, { class: "ss-card-alinhado" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form, { layout: "vertical" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_spin, {
                              spinning: _ctx.baixaTitulosBase.carregandoParametros
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Acréscimo",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_tipo_valor_financeiro, {
                                          valor: _ctx.baixaTitulosBase.tipoAcrescimo,
                                          "onUpdate:valor": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.baixaTitulosBase.tipoAcrescimo) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: _ctx.baixaTitulosBase.tipoAcrescimo === 2,
                                          percentual: _ctx.baixaTitulosBase.tipoAcrescimo === 1,
                                          valor: _ctx.baixaTitulosBase.valorAcrescimo,
                                          "onUpdate:valor": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.baixaTitulosBase.valorAcrescimo) = $event))
                                        }, null, 8, ["monetario", "percentual", "valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Desconto",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_tipo_valor_financeiro, {
                                          valor: _ctx.baixaTitulosBase.tipoDesconto,
                                          "onUpdate:valor": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.baixaTitulosBase.tipoDesconto) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: _ctx.baixaTitulosBase.tipoDesconto === 2,
                                          percentual: _ctx.baixaTitulosBase.tipoDesconto === 1,
                                          valor: _ctx.baixaTitulosBase.valorDesconto,
                                          "onUpdate:valor": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.baixaTitulosBase.valorDesconto) = $event))
                                        }, null, 8, ["monetario", "percentual", "valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_74, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("button", {
                                          class: "ant-btn ant-btn-primary ss-tamanho-completo",
                                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.calcularValores(false)))
                                        }, "Aplicar valores")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _hoisted_75,
                                  _createElementVNode("div", _hoisted_76, [
                                    _createVNode(_component_totalizador, {
                                      titulo: "TOTAL DA BAIXA",
                                      monetario: true,
                                      valor: _ctx.baixaTitulosBase.totalBaixa
                                    }, null, 8, ["valor"])
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["spinning"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                ((!_ctx.baixaTitulosBase.baixaComDetalhamentos))
                  ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: "3",
                      collapsible: _ctx.baixaTitulosBase.titulosBaixa.length > 0?'':'disabled'
                    }, {
                      header: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _createTextVNode("3º Passo")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _hoisted_77
                      ]),
                      default: _withCtx(() => [
                        (_ctx.baixaTitulosBase.passoAtivo === '3')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createVNode(_component_baixa_titulos_utilizacao_credito, {
                                empresa: _ctx.baixaTitulosBase.empresaSelecionada,
                                tipoBaixaOrigem: _ctx.ETipoTituloFinanceiro.Receber,
                                pessoasTitulos: _ctx.baixaTitulosBase.pessoasTitulos,
                                utilizarCreditosApenasMesmaPessoa: _ctx.baixaTitulosBase.utilizarCreditosApenasMesmaPessoa,
                                "onUpdate:utilizarCreditosApenasMesmaPessoa": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.baixaTitulosBase.utilizarCreditosApenasMesmaPessoa) = $event)),
                                totalBaixa: _ctx.baixaTitulosBase.totalBaixa,
                                creditosUtilizados: _ctx.baixaTitulosBase.creditosUtilizados,
                                "onUpdate:creditosUtilizados": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.baixaTitulosBase.creditosUtilizados) = $event)),
                                totalCreditosUtilizados: _ctx.baixaTitulosBase.totalCreditosUtilizados,
                                "onUpdate:totalCreditosUtilizados": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.baixaTitulosBase.totalCreditosUtilizados) = $event)),
                                valorRestante: _ctx.baixaTitulosBase.valorRestante,
                                onAtualizarTotalizadores: _cache[49] || (_cache[49] = ($event: any) => (_ctx.atualizarValorRestante()))
                              }, null, 8, ["empresa", "tipoBaixaOrigem", "pessoasTitulos", "utilizarCreditosApenasMesmaPessoa", "totalBaixa", "creditosUtilizados", "totalCreditosUtilizados", "valorRestante"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["collapsible"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_collapse_panel, {
                  key: "4",
                  collapsible: _ctx.baixaTitulosBase.titulosBaixa.length > 0?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.baixaTitulosBase.baixaComDetalhamentos? '3º' : '4º') + " Passo ", 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_79
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_baixa_titulos_lancamento_carteira, {
                        empresa: _ctx.baixaTitulosBase.empresaSelecionada,
                        tipoTituloFinanceiro: _ctx.ETipoTituloFinanceiro.Receber,
                        contaPadrao: _ctx.baixaTitulosBase.contaPadrao,
                        titulosLancados: _ctx.baixaTitulosBase.titulosLancados,
                        "onUpdate:titulosLancados": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.baixaTitulosBase.titulosLancados) = $event)),
                        totalBaixa: _ctx.baixaTitulosBase.totalBaixa,
                        totalTitulosLancados: _ctx.baixaTitulosBase.totalTitulosLancados,
                        "onUpdate:totalTitulosLancados": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.baixaTitulosBase.totalTitulosLancados) = $event)),
                        valorRestante: _ctx.baixaTitulosBase.valorRestante,
                        onAtualizarTotalizadores: _cache[52] || (_cache[52] = ($event: any) => (_ctx.atualizarValorRestante()))
                      }, null, 8, ["empresa", "tipoTituloFinanceiro", "contaPadrao", "titulosLancados", "totalBaixa", "totalTitulosLancados", "valorRestante"])
                    ])
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "5",
                  collapsible: _ctx.baixaTitulosBase.titulosBaixa.length > 0?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.baixaTitulosBase.baixaComDetalhamentos? '4º' : '5º') + " Passo ", 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_80
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_baixa_titulos_lancamento, {
                      empresa: _ctx.baixaTitulosBase.empresaSelecionada,
                      tituloApresentacao: 'Recebimento',
                      dataBaixa: _ctx.baixaTitulosBase.dataBaixa,
                      totalBaixa: _ctx.baixaTitulosBase.totalBaixa,
                      contaPadrao: _ctx.baixaTitulosBase.contaPadrao,
                      lancamentos: _ctx.baixaTitulosBase.lancamentosContaNormais,
                      "onUpdate:lancamentos": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.baixaTitulosBase.lancamentosContaNormais) = $event)),
                      totalLancamentos: _ctx.baixaTitulosBase.totalLancamentosContaNormais,
                      "onUpdate:totalLancamentos": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.baixaTitulosBase.totalLancamentosContaNormais) = $event)),
                      valorRestante: _ctx.baixaTitulosBase.valorRestante,
                      baixaComDetalhamentos: _ctx.baixaTitulosBase.baixaComDetalhamentos,
                      onAtualizarTotalizadores: _cache[55] || (_cache[55] = ($event: any) => (_ctx.atualizarValorRestante()))
                    }, null, 8, ["empresa", "dataBaixa", "totalBaixa", "contaPadrao", "lancamentos", "totalLancamentos", "valorRestante", "baixaComDetalhamentos"])
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "6",
                  collapsible: (_ctx.baixaTitulosBase.totalCreditosUtilizados > 0 || _ctx.baixaTitulosBase.totalTitulosLancados > 0 || _ctx.baixaTitulosBase.totalLancamentosContaNormais > 0)?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Confirmação")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_81
                  ]),
                  default: _withCtx(() => [
                    _hoisted_82,
                    _createVNode(_component_card, { class: "ss-card-alinhado" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: _ctx.baixaTitulosBase.colunasMovimentos.filter(item => item.visible),
                          "data-source": _ctx.baixaTitulosBase.movimentosFinanceiros,
                          pagination: false,
                          loading: _ctx.telaBase.carregando,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.key === 'Conta')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.obterDescricaoConta(record.movimentoFinanceiro.codigoConta)), 1))
                              : (column.key === 'DataMovimento')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.movimentoFinanceiro.dataMovimento)), 1))
                                : (column.key === 'DescricaoTipoMovimento')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.obterDescricaoTipoMovimento(record.movimentoFinanceiro.tipoMovimento)), 1))
                                  : (column.key === 'IdentificadorMovimento')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(record.movimentoFinanceiro.identificadorMovimento), 1))
                                    : (column.key === 'DescricaoMovimento')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(record.movimentoFinanceiro.descricao), 1))
                                      : (column.key === 'ValorMovimento')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.movimentoFinanceiro.valor,2)), 1))
                                        : (column.key === 'InfluenciaSaldo')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.movimentoFinanceiro.influenciaSaldo)), 1))
                                          : (column.key === 'MovimentoBaixa')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                _createElementVNode("span", null, [
                                                  _hoisted_91,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoConta(record.movimentoFinanceiro.codigoConta)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_92,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.movimentoFinanceiro.dataMovimento)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_93,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoTipoMovimento(record.movimentoFinanceiro.tipoMovimento)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_94,
                                                  _createTextVNode(" " + _toDisplayString(record.movimentoFinanceiro.identificadorMovimento), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_95,
                                                  _createTextVNode(" " + _toDisplayString(record.movimentoFinanceiro.descricao), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_96,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.movimentoFinanceiro.valor,2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_97,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.movimentoFinanceiro.influenciaSaldo)), 1)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            (_ctx.baixaTitulosBase.movimentosFinanceiros.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Nenhum lançamento adicionado ainda"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "RESUMO DOS MOVIMENTOS"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.baixaTitulosBase.totalCreditosUtilizados > 0?'ant-col ant-col-xs-12 ant-col-xl-2':'ant-col ant-col-xs-12 ant-col-xl-4')
                          }, [
                            _createVNode(_component_totalizador, {
                              titulo: "QUANTIDADES",
                              valor: (_ctx.baixaTitulosBase.movimentosFinanceiros.length),
                              casasDecimais: 0
                            }, null, 8, ["valor"])
                          ], 2),
                          ((_ctx.baixaTitulosBase.totalCreditosUtilizados > 0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createVNode(_component_totalizador, {
                                  titulo: "TOTAL CRÉDITO UTILIZADO",
                                  monetario: true,
                                  valor: _ctx.baixaTitulosBase.totalCreditosUtilizados
                                }, null, 8, ["valor"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_100, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL JUROS/MULTAS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalJurosMultaMovimentos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL ACRÉSCIMOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalAcrescimosMovimentos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.baixaTitulosBase.totalCreditosUtilizados > 0?'ant-col ant-col-xs-12 ant-col-xl-3':'ant-col ant-col-xs-12 ant-col-xl-4')
                          }, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL DESCONTOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalDescontosMovimentos
                            }, null, 8, ["valor"])
                          ], 2),
                          _createElementVNode("div", _hoisted_102, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL ABATIMENTOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalAbatimentosMovimentos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_103, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL MOVIMENTOS",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalMovimentoFinal
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL BAIXA",
                              monetario: true,
                              valor: _ctx.baixaTitulosBase.totalBaixa
                            }, null, 8, ["valor"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_105, [
                      (_ctx.baixaTitulosBase.alertaBaixa.visivel)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            message: _ctx.baixaTitulosBase.alertaBaixa.titulo,
                            description: _ctx.baixaTitulosBase.alertaBaixa.mensagem,
                            type: _ctx.baixaTitulosBase.alertaBaixa.tipo,
                            "show-icon": ""
                          }, null, 8, ["message", "description", "type"]))
                        : _createCommentVNode("", true)
                    ]),
                    ((_ctx.baixaTitulosBase.totalSobraValores > 0))
                      ? (_openBlock(), _createBlock(_component_baixa_titulos_lancamento_creditos, {
                          key: 0,
                          empresa: _ctx.baixaTitulosBase.empresaSelecionada,
                          tipoTituloFinanceiro: _ctx.ETipoTituloFinanceiro.Pagar,
                          totalSobraValores: _ctx.baixaTitulosBase.totalSobraValores,
                          contaPadrao: _ctx.baixaTitulosBase.contaPadrao,
                          creditosLancados: _ctx.baixaTitulosBase.creditosLancados,
                          "onUpdate:creditosLancados": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.baixaTitulosBase.creditosLancados) = $event)),
                          totalCreditosLancados: _ctx.baixaTitulosBase.totalCreditosLancados,
                          "onUpdate:totalCreditosLancados": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.baixaTitulosBase.totalCreditosLancados) = $event))
                        }, null, 8, ["empresa", "tipoTituloFinanceiro", "totalSobraValores", "contaPadrao", "creditosLancados", "totalCreditosLancados"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["collapsible"])
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_buscar_titulos_modal, {
      visivel: _ctx.baixaTitulosBase.exibirBuscaTitulos,
      "onUpdate:visivel": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.baixaTitulosBase.exibirBuscaTitulos) = $event)),
      empresa: _ctx.baixaTitulosBase.empresaSelecionada,
      tipoTitulo: _ctx.ETipoTituloFinanceiro.Receber,
      apenasTitulosPendentes: true,
      omitirTitulos: _ctx.baixaTitulosBase.titulosBaixa.map(c=>c.codigoTituloFinanceiro),
      onConfirmacao: _cache[61] || (_cache[61] = ($event: any) => (_ctx.popularTitulosBaixa($event)))
    }, null, 8, ["visivel", "empresa", "tipoTitulo", "omitirTitulos"]),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      retornoRequisicao: _ctx.modalBase.retornoRequisicao,
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
    }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
  ], 64))
}